<script lang="ts">
import { getAvailableProductText, getNotAvailable } from '../../helpers/common';

    import language from '../../lang/language';

    import productsStore, { searched } from '../../store/product';
import service from '../../store/service';
    import CardSkeleton from '../services/CardSkeleton.svelte';
    import ProductCard from './ProductCard.svelte';

    let products: any = productsStore.data;
    let isLoading = productsStore.data.isLoading;

    export let selectedService;

    export let onRequest;
</script>

<div class="service-wrapper">
    {#if $products}
        {#if $isLoading}
            <CardSkeleton numberOfSkeleton={1} />
        {:else if $searched}
            <div class="row">
                <div
                    class="row left-align primary-font-color subtitle font bordered nara-season"
                >
                    <h2 class="bg-before nara-season">
                        {getAvailableProductText(selectedService.Type)}
                    </h2>
                </div>
            </div>
            {#each $products as service}
                <ProductCard {service} {onRequest} {selectedService} />
            {:else}
            {getNotAvailable(selectedService.Type)}
            {/each}
        {/if}
    {/if}
</div>

<style>
    .subtitle {
        width: 100%;
        border-bottom: 3px solid purple;
        padding: 10px 0px;
    }

    .subtitle > h2 {
        position: relative;
        padding-left: 20px;
    }

    .subtitle > h2:before {
        content: '';
        height: 100%;
        width: 10px;
        background: linear-gradient(
            to bottom,
            rgba(172, 94, 140, 1) 0%,
            rgba(142, 34, 99, 1) 100%
        );
        position: absolute;
        top: 0;
        left: 0;
    }
</style>
